import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import BgImg from "../../../images/case-studies/soundly/challenge.webp";
function Challenge() {
  return (
    <div
      className="challenge_section p-100 case_soundly"
      style={{ backgroundImage: `url(${BgImg})` }}
    >
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={7} lg={7} xl={7} xxl={7} className="ms-auto my-auto">
            <h2>
              <span>The </span> Challenge
            </h2>
            <p>
              <span>
                The challenge was discovering the differentiating factor
                required to set the Soundly app apart from other competitors.
                Team Tekrevol had to develop innovative ideas to build a
                revolutionary interface for the app. Also, the app's
                functionality and features needed to be reimagined and designed
                to bring a whole new experience to the market.
              </span>
              <span>
                The comprehensive market research and scoping sessions were to
                be initiated from the get-go to come up with something that
                would ensure the app's success in the competitive marketplace.
              </span>
            </p>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Challenge;
